import React from 'react'

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">
            Privacy Policy
          </h1>
          
          <div className="prose prose-lg text-gray-700">
            <p className="mb-4">
              <strong>Ultimo aggiornamento:</strong> 8 Agosto 2024
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              1. Informazioni Generali
            </h2>
            <p className="mb-4">
              La Dolce Vita ("noi", "nostro", "ci") si impegna a proteggere la privacy dei nostri utenti. 
              Questa Privacy Policy spiega come raccogliamo, utilizziamo e proteggiamo le informazioni personali 
              che ci fornisci quando utilizzi il nostro servizio.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              2. Informazioni che Raccogliamo
            </h2>
            <p className="mb-4">
              Raccogliamo le seguenti informazioni personali:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Nome e indirizzo email</li>
              <li>Informazioni di contatto</li>
              <li>Dati di utilizzo del servizio</li>
              <li>Informazioni sui pagamenti</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              3. Come Utilizziamo le Informazioni
            </h2>
            <p className="mb-4">
              Utilizziamo le informazioni raccolte per:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Fornire e migliorare i nostri servizi</li>
              <li>Comunicare con te</li>
              <li>Processare i pagamenti</li>
              <li>Inviare aggiornamenti e newsletter</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              4. Condivisione delle Informazioni
            </h2>
            <p className="mb-4">
              Non vendiamo, affittiamo o condividiamo le tue informazioni personali con terze parti, 
              eccetto nei casi previsti dalla legge o con il tuo consenso esplicito.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              5. Sicurezza dei Dati
            </h2>
            <p className="mb-4">
              Implementiamo misure di sicurezza appropriate per proteggere le tue informazioni personali 
              da accesso non autorizzato, alterazione, divulgazione o distruzione.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              6. I Tuoi Diritti
            </h2>
            <p className="mb-4">
              Hai il diritto di:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Accedere alle tue informazioni personali</li>
              <li>Correggere informazioni inesatte</li>
              <li>Richiedere la cancellazione dei tuoi dati</li>
              <li>Opporti al trattamento dei tuoi dati</li>
            </ul>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4" id="cookies">
              7. Cookie e Tecnologie Simili
            </h2>
            <p className="mb-4">
              Utilizziamo cookie e tecnologie simili per:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li><strong>Cookie necessari:</strong> Essenziali per il funzionamento del sito</li>
              <li><strong>Cookie di analytics:</strong> Per analizzare l'utilizzo del sito e migliorare i nostri servizi</li>
              <li><strong>Cookie di marketing:</strong> Per mostrare contenuti personalizzati (solo con il tuo consenso)</li>
            </ul>
            <p className="mb-4">
              Puoi gestire le tue preferenze sui cookie attraverso il banner che appare sul nostro sito o 
              utilizzando il link "Gestisci Cookie" nel footer.
            </p>
            <div className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded mb-4">
              <p className="text-blue-700 text-sm">
                <strong>Nota:</strong> Per maggiori informazioni sui cookie, consulta anche la nostra 
                <a href="/terms-and-conditions" className="underline hover:text-blue-900 ml-1">
                  Informativa sui Cookie
                </a> 
                nella sezione Termini e Condizioni.
              </p>
            </div>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              9. Modifiche alla Privacy Policy
            </h2>
            <p className="mb-4">
              Ci riserviamo il diritto di modificare questa Privacy Policy in qualsiasi momento. 
              Le modifiche saranno pubblicate su questa pagina con una data di aggiornamento.
            </p>

            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-4">
              10. Contattaci
            </h2>
            <p className="mb-4">
              Se hai domande su questa Privacy Policy, contattaci a:
            </p>
            <p className="mb-4">
              <strong>Email:</strong> privacy@ladolcevita.com<br />
              <strong>Indirizzo:</strong> Via Roma 123, 65000 Pescara, Italia
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PrivacyPolicyPage 